import { render, staticRenderFns } from "./CenterColumn.vue?vue&type=template&id=78fa392b&scoped=true&"
import script from "./CenterColumn.vue?vue&type=script&lang=js&"
export * from "./CenterColumn.vue?vue&type=script&lang=js&"
import style0 from "./CenterColumn.vue?vue&type=style&index=0&id=78fa392b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa392b",
  null
  
)

export default component.exports